import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './tooltip.scss'

export const SIZES = ['small', 'medium', 'large']

const Tooltip = (props) => {
  const { children, legend, inline, size, className } = props

  const tooltipClass = classNames(styles.tooltip, className, {
    [styles.inline]: inline,
    [styles[size]]: size
  })

  return (
    <div className={tooltipClass}>
      {children}

      <div className={styles.tooltip}>
        <div className={styles.content}>
          <div>{legend}</div>
        </div>
      </div>
    </div>
  )
}

Tooltip.defaultProps = {
  children: null,
  legend: null,
  inline: null,
  className: null,
  size: null
}

Tooltip.propTypes = {
  legend: PropTypes.string,
  inline: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element
  ]),
  className: PropTypes.string,
  size: PropTypes.oneOf(SIZES)
}

export default Tooltip
